module.exports = __webpack_public_path__ + "static/media/location.23c6b18e.png";